import React from "react";
import {Avatar} from "antd";
import {CandidateIcon} from "config/icons";
import {TruncatedText} from "../../../../../platform/Table/TruncatedText";
import styles from '../style.module.scss'

export interface MultiAccountViewProps {
  email: string
  src: string
  name: string
  onClick: (e: React.MouseEvent<HTMLElement>) => void,
}
export const MultiAccountView = (props: MultiAccountViewProps) => {
  const { email, name, onClick, src = '' } = props
    return (
      <div className={styles.accountContainer} onClick={onClick}>
        <div className="mr-2">
          <Avatar
            src={src}
            icon={<CandidateIcon />}
            size={35}
          />
        </div>
        <div>
          <div style={{ fontWeight: 500 }}>
            <TruncatedText
              size={18}
              text={name}
            />
          </div>
          <TruncatedText
            size={18}
            text={email}
          />
        </div>
      </div>
    )
}
